import { render, staticRenderFns } from "./TabsLayout.vue?vue&type=template&id=3464d919&"
import script from "./TabsLayout.vue?vue&type=script&lang=js&"
export * from "./TabsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3464d919')) {
      api.createRecord('3464d919', component.options)
    } else {
      api.reload('3464d919', component.options)
    }
    module.hot.accept("./TabsLayout.vue?vue&type=template&id=3464d919&", function () {
      api.rerender('3464d919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tabs/TabsLayout.vue"
export default component.exports